var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrenadeLauncher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.014 49.4625L110.594 42.177L108.989 41.502L106.423 36.3915C106.423 36.3915 106.484 34.509 106.805 33.477C107.126 32.4465 108.266 31.7805 109.027 31.533C109.787 31.2855 110.3 31.533 110.3 31.533L111.101 30.69L111.355 27.7335L109.159 25.2L106.625 25.284L106.541 26.1285L104.683 25.959L102.317 24.354L102.487 22.665L100.882 23.256L97.2758 20.2995H98.7698L98.6858 18.357H95.9828L95.1383 19.032L94.1243 18.948L93.0548 17.9145L91.3373 17.7645L88.9718 14.133H86.3528L85.5083 15.4845H82.1303L81.4553 16.329L76.9328 16.5225L75.7958 17.0895L52.0538 16.899L51.0473 16.161H40.0658V12.444L21.6518 11.937L20.3003 12.444H17.5133L14.1353 15.654H8.81183L7.95233 15.1035L5.10833 10.6635L4.86983 22.0755L2.47583 22.92L3.06983 25.7265L4.86983 26.8065V31.833H27.5528V33.8175L25.5638 34.014L24.6068 34.4085L22.7483 33.648H7.71383L6.10883 34.899V38.463L7.71383 39.3075H22.7498L24.5243 38.379L26.1293 39.3075H27.5543L28.2413 40.068H35.2523C35.2523 40.068 37.7408 37.005 38.5463 36.0135C39.3518 35.022 41.3333 34.8315 41.3333 34.8315L61.9433 35.0565L62.7878 37.0275L66.0818 36.9435V33.987L82.8068 41.082H94.0583L95.4773 41.673H98.1803L99.4478 44.5455L98.9408 45.6435L99.4478 46.7415H101.39L103.756 52.0635L102.911 53.331L103.334 54.345L106.037 54.7905L113.893 52.4025L114.484 50.46L114.017 49.467L114.014 49.4625ZM79.4258 35.1105L76.6103 33.816V32.9145H80.2703L79.4258 35.1105ZM87.4928 37.4055L85.1693 38.0385L80.7353 35.8425L81.9608 32.9145H85.8458L87.4928 34.365V37.4055V37.4055ZM98.5163 36.573C98.5163 38.283 97.1303 39.669 95.4203 39.669H92.1953C90.4853 39.669 89.0993 38.283 89.0993 36.573C89.0993 34.863 90.4853 33.477 92.1953 33.477H92.6918C92.6918 33.477 94.2938 34.8285 94.4063 36.237C94.5188 37.6455 93.8093 38.391 93.8093 38.391C93.8093 38.391 94.5188 39.0525 95.3078 38.3775C95.3078 38.3775 97.1693 36.351 95.4218 33.4785C97.1318 33.4785 98.5178 34.8645 98.5178 36.5745L98.5163 36.573Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8362 23.508V25.3695",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4973 23.508V25.3695",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1584 23.508V25.3695",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8196 23.5081V25.3696",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4807 23.5081V25.3696",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1399 23.508V25.3695",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.801 23.5081V25.3696",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4622 23.5081V25.3696",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1233 23.5081V25.3696",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7834 23.5081V25.3696",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4436 23.5081V25.3696",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1047 23.5081V25.3696",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7649 23.5081V25.3696",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4263 23.508V25.3695",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2991 22.074V26.8035",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2368 25.881H75.2343",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.718 29.088H80.2715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3313 34.8285V32.295H61.7298V34.575",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.511 12.444V15.4845",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2983 12.444V15.4845",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3127 11.937V15.654",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8967 21.5955V26.55L104.767 29.088L104.683 25.959",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8967 26.55H92.6917",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0547 23.0595H96.8822",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0547 24.129H96.8822",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0547 25.1985H96.8822",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.275 40.614L105.992 38.967L108.864 44.499C108.864 44.499 109.497 45.3855 110.3 45.3435V50.2425C110.3 50.2425 110.366 51.2985 109.614 51.72C108.863 52.1415 107.427 52.692 107.427 52.692L102.275 40.6125V40.614Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M103.161 32.9145C103.737 32.9145 104.203 32.4477 104.203 31.872C104.203 31.2962 103.737 30.8295 103.161 30.8295C102.585 30.8295 102.118 31.2962 102.118 31.872C102.118 32.4477 102.585 32.9145 103.161 32.9145Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102.654 37.404C102.864 37.404 103.034 37.2341 103.034 37.0245C103.034 36.8149 102.864 36.645 102.654 36.645C102.445 36.645 102.275 36.8149 102.275 37.0245C102.275 37.2341 102.445 37.404 102.654 37.404Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9848 40.0231C87.3112 40.0231 87.5758 39.7585 87.5758 39.4321C87.5758 39.1057 87.3112 38.8411 86.9848 38.8411C86.6584 38.8411 86.3938 39.1057 86.3938 39.4321C86.3938 39.7585 86.6584 40.0231 86.9848 40.0231Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2508 28.1565C91.3444 28.1565 91.4203 28.0806 91.4203 27.987C91.4203 27.8934 91.3444 27.8175 91.2508 27.8175C91.1572 27.8175 91.0813 27.8934 91.0813 27.987C91.0813 28.0806 91.1572 28.1565 91.2508 28.1565Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4029 32.295C68.8237 32.295 69.1649 31.9538 69.1649 31.533C69.1649 31.1122 68.8237 30.771 68.4029 30.771C67.982 30.771 67.6409 31.1122 67.6409 31.533C67.6409 31.9538 67.982 32.295 68.4029 32.295Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1557 25.368C53.3893 25.368 53.5787 25.1786 53.5787 24.945C53.5787 24.7114 53.3893 24.522 53.1557 24.522C52.9221 24.522 52.7327 24.7114 52.7327 24.945C52.7327 25.1786 52.9221 25.368 53.1557 25.368Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8012 31.1385C60.9718 31.1385 61.1102 31.0002 61.1102 30.8295C61.1102 30.6589 60.9718 30.5205 60.8012 30.5205C60.6305 30.5205 60.4922 30.6589 60.4922 30.8295C60.4922 31.0002 60.6305 31.1385 60.8012 31.1385Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M34.025 36.771C34.6314 36.771 35.123 36.2794 35.123 35.673C35.123 35.0665 34.6314 34.575 34.025 34.575C33.4186 34.575 32.927 35.0665 32.927 35.673C32.927 36.2794 33.4186 36.771 34.025 36.771Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6519 16.1611H40.0639V11.9371H21.6499L20.2984 12.4441H17.5114L14.1334 15.6541H8.30438L4.86938 10.2901V31.8301H27.5524V33.8146H26.0419L24.6064 34.4056L22.7479 33.6451H7.71338L6.10839 34.4056V38.4601L7.88288 39.3046H22.7494L24.5239 38.3761L26.1289 39.3046H27.5539L28.2409 40.0651H35.2519L38.5459 36.0106C38.5459 36.0106 39.1369 34.8286 41.3329 34.8286C43.5289 34.8286 61.9429 34.9126 61.9429 34.9126L62.7874 37.0246L66.0814 36.9406V33.9841L82.8064 41.0791H94.4629L95.4769 41.6701H98.1799L99.4474 44.5426L98.9404 45.6406L99.4474 46.7386H101.39L103.755 52.0606L102.911 53.3281L103.334 54.3421L106.037 54.7876L113.892 52.3996L114.483 50.4571L110.598 42.1786L108.993 41.5036L106.881 37.2796C106.881 37.2796 105.699 35.0836 107.135 32.8876C108.57 30.6916 110.429 31.7896 110.429 31.7896L111.104 30.6916L111.357 27.7351L109.161 25.2016L106.628 25.2856L106.544 26.1301L104.685 25.9606L102.32 24.3556L102.489 22.6666L100.884 23.2576L96.6604 20.3011H98.7724L98.6884 18.3586H95.9854L95.1409 19.0336L94.1269 18.9496L93.2824 17.9356L91.3399 17.7661L88.9744 14.1346H86.3554L85.5109 15.4861H82.1329L81.4579 16.3306H77.1499L76.3054 17.0911H52.3159L51.0484 16.1626H46.6564V4.2511",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86983 26.8036L2.47583 25.3681V22.9186L4.86983 22.0741H52.9883L56.7053 24.9451L55.7753 26.8036H4.86983Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71411 33.6451V39.3046",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7483 33.6451V39.3046",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6069 34.4056L24.5229 38.3761",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5527 33.8146V39.3046",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5437 36.0106C38.5437 36.0106 36.6221 38.3761 34.2356 38.3761C30.9416 38.3761 30.9417 35.2501 30.9417 35.2501V29.0881H39.7826L40.5717 30.4921H52.4531L53.5227 28.5781H64.7847L63.9402 35.0536H61.9406",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6104 32.9131H80.2719L79.4258 35.1106L76.6104 33.8146V32.9131Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9609 32.9131H85.8459L87.4929 34.3636V37.4041L85.1709 38.0386L80.7354 35.8426L81.9609 32.9131Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9879 22.0741L51.2134 20.8066L49.7779 18.4411H31.3639L29.5894 15.6541H4.86938",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4403 28.5781L79.6793 29.0881H88.1273V25.8751L86.3528 23.4256L82.5518 21.2296H73.8518L75.8273 24.6391",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4654 28.3831C78.6972 28.3831 79.6959 27.3844 79.6959 26.1526C79.6959 24.9207 78.6972 23.9221 77.4654 23.9221C76.2335 23.9221 75.2349 24.9207 75.2349 26.1526C75.2349 27.3844 76.2335 28.3831 77.4654 28.3831Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3361 17.7661L92.6876 20.3851V27.9871C92.6876 27.9871 92.8286 29.4451 91.3361 29.5186C89.8436 29.5921 89.8151 27.9016 89.8151 27.9016V20.2426L85.5071 15.4846",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6917 29.0881H109.159",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M109.615 25.7236V31.5331",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1272 29.0881L89.5057 32.1256H97.5022L100.925 35.1106H106.424",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M100.925 35.1106L98.1787 41.6701",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4204 33.4771C97.1679 36.3496 95.3064 38.3761 95.3064 38.3761C94.5174 39.0511 93.8079 38.3896 93.8079 38.3896C93.8079 38.3896 94.5174 37.6441 94.4049 36.2356C94.2924 34.8271 92.6904 33.4756 92.6904 33.4756H92.1939C90.4839 33.4756 89.0979 34.8616 89.0979 36.5716C89.0979 38.2816 90.4839 39.6676 92.1939 39.6676H95.4189C97.1289 39.6676 98.5149 38.2816 98.5149 36.5716C98.5149 34.8616 97.1289 33.4756 95.4189 33.4756L95.4204 33.4771Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4202 33.4771H92.6917",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0644 16.1611H29.9124",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrenadeLauncher);
export default __webpack_public_path__ + "static/media/Grenade Launcher.72c510aeff648f518f13d15b349d0cea.svg";
export { ForwardRef as ReactComponent };